<template>
  <div id="app">
    <div>
      <NavBar/>
      <router-view/>
      <Footer/>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import Footer from '@/components/Footer'
export default {
  name: 'App',
  components: {
    NavBar,
    Footer
  }
}
</script>

<style>
#app {
  @import "assets/css/style.css";
}
</style>



// WEBPACK FOOTER //
// src/App.vue